import React from 'react'
import "../../CSS/Shop/tituloPrincipal.css"


const TituloPrincipalDaPaginaShop = () => {
  return (
    <div>
        <h2>Best Selling Products</h2>
    </div>
  )
}

export default TituloPrincipalDaPaginaShop